import { CircularProgress, Stack } from '@mui/material';

interface ILoader {
  scale?: string;
  sx?: any;
  size?: number;
}

export const Loader = ({ scale, sx, size }: ILoader) => {
  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: sx ? sx.height : '50vh',
        gap: '32px',
        transform: scale,
        ...sx,
      }}
    >
      <CircularProgress size={size || 100} />
    </Stack>
  );
};
